import { useContext, useEffect } from 'react'

import { Outlet } from 'react-router-dom'

import DataContext from 'src/contexts/DataContext'

interface IInitialContextProps {
  course: string
}

const InitialContext = (props: IInitialContextProps) => {
  const { registration, setRegistration } = useContext(DataContext)

  useEffect(() => {
    if (registration.setCourse)
      registration.setCourse(setRegistration, props.course)
  }, [])

  return <Outlet />
}

export { InitialContext }
